import { COMP } from '@pages/admin/layouts/data'
import { Breakpoint, BreakpointCols } from '@pages/admin/layouts/types'

export const getColsForBreakpoint = (breakpoint: Breakpoint): number => {
  return BreakpointCols[breakpoint] ?? 10
}

export const findWidgetById = (id: any, children: any) => {
  for (const child of children) {
    if (child.id === id && child.category === COMP.WIDGET.CATEGORY) {
      return child
    } else if (child.children) {
      const result: any = findWidgetById(id, child.children)
      if (result) {
        return result
      }
    }
  }
  return null
}

export const getResponsiveHeight = () => {
  const viewportH = window.innerHeight

  if (viewportH >= 900) return 12
  if (viewportH >= 700) return 10
  if (viewportH >= 600) return 8
  if (viewportH >= 500) return 6
  return 4
}
